// Save state, gotta love my save state
export const QueryBuilderState = Object.freeze({
	SAVED: 'SAVED',
	NOT_SAVED: 'NOT_SAVED',
	SAVING: 'SAVING',
	PERFORMING_QUERY: 'PERFORMING_QUERY',
	DONE: 'DONE',
	NONE: 'NONE',
});
